import { forwardRef } from 'react';
import type { BasicInputProps } from '../basic-input';
import { BasicInput } from '../basic-input';

type TextInputProps = Omit<BasicInputProps, 'type'>;

export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  (props, ref) => <BasicInput ref={ref} type="text" {...props} />
);

TextInput.displayName = 'TextInput';
